/**
 * Product card — fast add to cart (Gudslip / Gudsport).
 * Delegado: cualquier [data-fast-add] (con data-variant-id) añade esa variante por
 * AJAX y dispara `cart:updated` → iurop-cart-drawer.js refresca y ABRE el sidecart.
 * Ver NOTAS-DESARROLLO.md §3.7.
 */
(function () {
  'use strict';

  // Guard de reentrada: este script lo cargan varias secciones que pueden coexistir
  // (cart-drawer global + grid/split/plp) y cada <script> con el mismo src SE EJECUTA
  // → sin guard el listener delegado se registra N veces y un click añade N unidades.
  // Ver NOTAS §4.
  if (window.__gudslipFastAdd) return;
  window.__gudslipFastAdd = true;

  var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

  // QA 2026-08-14 (SC6) "le pulsas varias veces el + y te suma 3": el candado
  // era la clase is-loading del BOTÓN y se soltaba en cuanto respondía
  // /cart/add.js, pero el sidecart tarda otro segundo largo en repintarse (va por
  // Section Rendering). En esa ventana el usuario no ve nada nuevo, vuelve a
  // pulsar y se añade otra unidad. Ahora el candado es POR VARIANTE y no se
  // suelta hasta que el repintado ha tenido tiempo de entrar.
  var enVuelo = {};
  var LOCK_MS = 1400;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fast-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id || enVuelo[id] || btn.classList.contains('is-loading') || btn.hasAttribute('disabled')) return;

    enVuelo[id] = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    var soltar = function () {
      delete enVuelo[id];
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    };
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) { soltar(); return; }
        // El botón sigue bloqueado hasta que el sidecart termina de repintarse.
        window.setTimeout(soltar, LOCK_MS);
        btn.classList.add('is-added');
        window.setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(soltar);
  });
})();
